<template>
  <div v-if="loading">
    <sdCards headless>
      <div class="spin">
        <a-spin />
      </div>
    </sdCards>
  </div>
  <div v-else >
    <sdPageHeader title="All Sub Clients">
      <template v-slot:subTitle> 
        <a-button size="default" type="text" style="border: none;">
          <h3>Total Clients Connected <span style="padding: 6px 10px; background:#2e2a2a; border-radius: 50%; color: #fff;"><b>{{counts}}</b></span></h3>
        </a-button>
        <a-button
          size="default"
          type="text"
          class="btn-signin"
          style="
            border: none;
            vertical-align: middle;
            transform: rotateZ(270deg);
          "
        >
          <span>
            <sdFeatherIcons
              style="line-height: 0; color: black !important"
              type="bar-chart"
              size="18"
          /></span>

        </a-button>
      </template>
      <template v-slot:buttons>
        <div class="page-header-actions" style="margin-left: -70px;">
          <a-button
            class="btn-signin"
            size="small"
            @click="$router.go(-1)"
           style="position: absolute !important;"
          >
            <span
              style="
                display: inline-flex !important;
                align-items: center !important;
              "
            >
              <sdFeatherIcons type="arrow-left" size="14" /> &nbsp;
              Back</span
            >
          </a-button>
        </div>
        <span style="margin: 0px; font-size: 16px; font-weight: 400">
          <br />
          <br />
          &nbsp;
        </span>
      </template>
    </sdPageHeader>
     
    <Main>
    
      <div v-if="empty">
        <sdCards headless>
          <div class="spin">
            <a-spin />
          </div>
        </sdCards>
      </div>
      <div v-else>
          
        <a-row :gutter="25">
          <a-col :md="24">
            <div headless v-if="empty">
              <div v-if="loading">
                <sdCards headless>
                  <div class="spin">
                    <a-spin />
                  </div>
                </sdCards>
              </div>
              <div v-else>
                <a-empty
                  image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
                  :image-style="{
                    height: '160px',
                  }"
                >
                  <template v-slot:description>
                    <h3>Clients not connected yet !</h3>
                  </template>
                  <div class="page-header-actions">
                    <a-button type="primary" v-on:click="xeroconnect()">
                      add client
                    </a-button>
                  </div>
                </a-empty>
              </div>
            </div>
            <div headless v-else>
              <a-list
                style="margin: 0px"
                class="demo-loadmore-list"
                item-layout="horizontal"
                :data-source="usersTableData"
              >
                <template #renderItem="{ item }">
                  <ProductCard
                    class="list-view"
                    :style="{ marginBottom: '20px' }"
                  >
                    <div class="product-list" style="padding: 10px">
                      <a-row :gutter="15">
                        <a-col :md="2" :xs="24">
                          <figure style="margin-left: 20px">
                            <img
                              :style="{ width: '40px' }"
                              :src="
                                require('@/static/img/auth/Illustration.png')
                              "
                              alt=""
                            />
                          </figure>
                        </a-col>
                        <a-col
                          :md="13"
                          :xs="24"
                          v-on:click="overviewpage(item.tenent_id,item.vendor)"
                        >
                          <div class="product-single-description">
                            <sdHeading
                              class="product-single-title"
                              as="h6"
                              style="margin: 0px; font-size: 16px"
                            >
                              {{ item.client_name }}
                            </sdHeading>
                            <p style="margin: 0px; font-size: 14px">
                              Last Sync:
                              {{
                                item.lastsync == "not_synced"
                                  ? "Not Synced"
                                  : item.lastsync
                              }}
                            </p>
                            <p style="margin: 0px; font-size: 14px">
                              Synced Notification:
                              {{
                                item.notification
                              }}
                            </p>
                            <p style="margin: 0px; font-size: 14px; color: #ff0f0f;">
                              {{
                                item.connection_status
                              }}
                            </p>
                          </div>
                          
                        </a-col>
                        
                        <a-col :md="1" :xs="24">
                          <div class="product-single-description">
                            <sdHeading
                              class="product-single-title"
                              as="h6"
                              style="margin: 10px 0px 0px 20px; font-size: 16px"
                            >
                              <sdFeatherIcons type="heart" size="20"
                            /></sdHeading>
                          </div>
                        </a-col>
                        <a-col :md="2" :xs="24">
                          <div class="product-single-description">
                            <sdHeading
                              class="product-single-title"
                              as="h6"
                              style="margin: 10px 0px 0px 0px; font-size: 16px"
                            >
                              {{ item.health_score }} %
                            </sdHeading>
                          </div>
                          </a-col>
                          
                        
                        <a-col :md="1" :xs="24">
                          <div class="product-single-description">
                            <sdHeading
                              class="product-single-title"
                              as="h6"
                              style="margin: 10px 0px 0px 0px; font-size: 16px"
                            >
                              <Action class="table-actions">
                                <sdFeatherIcons
                                  v-on:click="
                                    startactive(item.id, item.tenent_id)
                                  "
                                  v-bind:class="[
                                    item.favourite ? 'active' : 'deactivate',
                                    'deactive',
                                  ]"
                                  key=""
                                  type="star"
                                  size="20px"
                                />
                              </Action>
                            </sdHeading>
                          </div>
                        </a-col>
                        <a-col :md="1" :xs="24">
                          <div class="product-single-description">
                            <sdHeading
                              class="product-single-title"
                              as="h6"
                              style="margin: 10px 0px 0px 0px; font-size: 16px"
                            >
                              <sdDropdown>
                                <template #overlay>
                                  <a
                                    href="https://go.xero.com/Dashboard/"
                                    target="_blank" v-if="item.vendor!='QBO'"
                                  >
                                    <span>View</span>
                                  </a>
                                  <router-link to="#">
                                    <a-popconfirm
                                      title="Are you sure you want to Resync?"
                                      ok-text="Yes"
                                      cancel-text="No"
                                      @confirm="openModal(item.tenent_id,'Report')"
                                    >
                                    <span>Report Sync</span>
                                     </a-popconfirm>
                                  </router-link>
                                  <router-link to="#" >
                                    <span v-if="!item.connection_status || item.connection_status.trim() === ''">
                                    <a-popconfirm
                                      title="Are you sure you want to sync?"
                                      ok-text="Yes"
                                      cancel-text="No"
                                      @confirm="openModal(item.tenent_id,'Resync')"
                                    >
                                    <span >Sync </span>
                                     </a-popconfirm>
                                     </span>
                                     <span v-else>
                                    <a-popconfirm
                                      title="Are you sure you want to sync?"
                                      ok-text="Yes"
                                      cancel-text="No"
                                      @confirm="openModal1()"
                                    >
                                    <span >Sync </span>
                                     </a-popconfirm>
                                     </span>
                                  </router-link>
                                  <router-link to="#" v-if="item.vendor!='QBO'">
                                    <a-popconfirm
                                      title="Are you sure you want to Unsync?"
                                      ok-text="Yes"
                                      cancel-text="No"
                                      @confirm="xeroResync(item.tenent_id,)"
                                    >
                                    <span>Unsync</span>
                                     </a-popconfirm>
                                  </router-link>
                                  <router-link to="#" v-if="item.vendor!='QBO'" >
                                    <a-popconfirm
                                      title="Note: It will disconnect Xero App Connection & Delete all the of the client"
                                      ok-text="Yes"
                                      cancel-text="No"
                                      @confirm="xerodisconnect(item.tenent_id)"
                                    >
                                      <span>Disconnect</span>
                                    </a-popconfirm>
                                  </router-link>
                                  <router-link to="#" v-if="item.vendor=='QBO'" >
                                    <a-popconfirm
                                      title="Note: It will disconnect QBO App Connection & Delete all the of the client"
                                      ok-text="Yes"
                                      cancel-text="No"
                                      @confirm="qbodisconnect(item.tenent_id)"
                                    >
                                      <span>Disconnect QBO</span>
                                    </a-popconfirm>
                                  </router-link>
                                  <router-link to="/help">
                                  <span>Help</span>
                                  </router-link>
                                </template>
                                <router-link to="#">
                                  <sdFeatherIcons
                                    type="more-vertical"
                                    size="20px"
                                    color="Black"
                                  />
                                </router-link>
                              </sdDropdown>
                            </sdHeading>
                          </div>
                        </a-col>
                        <a-col :md="2" :xs="24">
                         <HalfProgressBar :percent="item.sync_percent" />
                        </a-col>
                      </a-row>
                    </div>
                  </ProductCard>
                </template>
              </a-list>
            </div>
          </a-col>
       </a-row>
       <Modal v-show="showModal" :var="ten_id" @close-modal="showModal = false" />
       <a-modal
        :type="localState.modalType"
        title="Client Reconnection"
        :visible="localState.schedVisible"
        :footer="null"
        :onCancel="handleCancel"
        :width= "720"
      >
        <div class="project-modal">
        <a-row :gutter="15">
          <a-col :md="24">
            <h2>Reconnection Alert!(Xero connection lost): Please reconnect the client!</h2>
           </a-col>
        </a-row>
       </div>
      </a-modal>
      
      <a-modal
        :type="localState.modalType"
        title="User Guide"
        :visible="localState.guideVisible"
        :footer="null"
        :onCancel="handleCancel"
        :width= "1024"
      >
        <div class="project-modal">
        <a-row :gutter="15">
          <a-col :md="24">
           <h1><sdFeatherIcons type="users" size="28"/> User Manual </h1>
           <h3>Below is the standard process to Add/Sync new client or existing client in the analytics:</h3>
           <ul>
            <li><sdFeatherIcons type="check-square" size="14"/> If the client is not connected:</li>
            <ol>
            <li>Connect a client using the Connect button.</li>
            <li>Sync the client add date range to Sync.(Parent Sync Period)</li>
            <li>Add Report sync Period at same time after adding Sync Period (Child Sync Period)</li>
            <li>Wait for 10-15 mins to complete the client sync Progress bar will show 100%.</li>
            <li>then you can Click GetCounts Button on top right corner of dashboard to Get Health Score & All the Counts of annexure.</li>
            <li>Now, you can use client to review the annexure</li>
            </ol>
            <li><sdFeatherIcons type="check-square" size="14"/> If the client already Connected in the Past and Synced:</li>
            <ol>
            <li>If the client Xero Access token Expired: </li>
            <ul>
            <li><sdFeatherIcons type="chevron-right" size="14"/> Unsync the client.</li>
            <li><sdFeatherIcons type="chevron-right" size="14"/> Disconnect the Client.</li>
            <li><sdFeatherIcons type="chevron-right" size="14"/> Then Follow the Above 1-5 steps of new Client Connection.</li>
            </ul>
            <li>If the client Connected but the Xero Access token not expired:</li>
            <ul>
            <li><sdFeatherIcons type="chevron-right" size="14"/> Unsync the client.</li>
            <li><sdFeatherIcons type="chevron-right" size="14"/> Then Follow the Above 2-5 steps of new Client Connection.</li>
            </ul>
            </ol>
           </ul>
           <h2>Key Terms </h2>
           <ol>
           <li><b>Connect:</b> Add the xero client/tenant to the Analytics </li>
            <li><b>View:</b> Shows selected client in Xero dashboard in new tab.</li>
            <li><b>Sync:</b> This functionality used add parent sync period, This is a major period required by user to store clients data to database(takes time depends on data synced).</li>
            <li><b>Report Sync:</b> This is inclusive period of synced period which is used to Review reports(If not added annexure will not show reports).</li>
            <li><b>Unsync:</b> Removes all sync period and synced data from Analytics and resets client Sync status to Not Synced.</li>
            <li><b>Disconnect:</b> Removes Connected client from Analytics dashboard and disconnect it from Xero app.</li>
            </ol>
          <a-button style="margin: 0 auto !important;"><a href="/Analytics User Guide.pdf" target="_blank">More Detailed Document</a></a-button>
           </a-col>
        </a-row>
       </div>
      </a-modal>
       </div>

    </Main>
  </div>
</template>
<script>
import { Main, TableWrapper } from "../styled";
import { computed, ref, defineComponent, onMounted,reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { UserTableStyleWrapper, Action, ProductCard } from "./style";
import * as FontAwesomeIcon from "@fortawesome/free-solid-svg-icons";
import Modal from "/src/components/Modal.vue";
import HalfProgressBar from "/src/components/utilities/progressBar.vue";
import { message, Notification } from 'ant-design-vue';

export default defineComponent({
  name: "dashboard",
  components: {
    Main,
    TableWrapper,
    UserTableStyleWrapper,
    Modal,
    HalfProgressBar,
    ProductCard,
    FontAwesomeIcon,
    Action,
    
  },
 
  setup() {
    let empty = ref(true);
    let loading = ref(true);
    var counts =ref(null);
    let orgdata = ref(null);
    let showModal= ref(false);
    let reconnect=ref(false);
    var msg = "";
    
    const param = useRoute();
    const router = useRouter();
    const { state, dispatch } = useStore();
    const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
    onMounted(() => {
      xerocheck();
      const modalOpened = localStorage.getItem("modalOpened");
    if (modalOpened !== "true") {
    openModal2();
    localStorage.setItem("modalOpened", "true");
    }
    window.setInterval(() => {
        updatecount();
    }, 15000);
      //window.setInterval(() => {
      //  let filter_data = JSON.parse(localStorage.getItem("search_data"));
      //  if(filter_data){
      //    state.xeroclient.data = filter_data;
      //  }
     // }, 500);
    });
    const localState = reactive({
      selectedRowKeys: 0,
      selectedRows: 0,
      visible: false,
      schedVisible: false,
      guideVisible: false,
      modalType: "primary",
      url: null,
    });
    const handleCancel = () => {
      localState.schedVisible= false;
      localState.guideVisible= false;
    };
    var ten_id="";
    const openModal = (tenent_id,output) => {
    ten_id=tenent_id;
    var out=output;
    //alert(tenent_id);
    localStorage.setItem("ten_id", ten_id);
    localStorage.setItem("output", out);
    showModal.value=true;
    }
    const openModal1 = () => {
    localState.schedVisible = true;
    }
    const openModal2 = () => {
    localState.guideVisible = true;

    }
    const xerocheck = () => {
    localStorage.removeItem("search_data");
    localStorage.removeItem("filter_data");
      if (param.params.id) {
        dispatch("xerosave", param.params.id.toString()).then(
          (response) => {
            router.push("/");
          },
          (error) => {
            // console.log(error);
            empty.value = true;
          }
        );
        empty.value=false;
        loading.value = false;
      } else {
        dispatch("getclientlist").then(
          (response) => {
            state.xeroclient.data = response.data;
            counts.value = response.data[0].total_clients_connected;
            //alert(counts.value);
            localStorage.setItem("search_data",JSON.stringify(response.data));
            //localStorage.setItem("filter_data",JSON.stringify(response.data));
            empty.value = false;
            loading.value = false;
          },
          (error) => {
            // console.log(error);
            empty.value = false;
            loading.value = false;
          }
        );
        
      }
    };
    
    const updatecount = () => {
      if(window.location.pathname == '/subclients'){
        dispatch("getsyncdata").then(
          (response) => {
            response.data.map((client,index) => {
              if(state.xeroclient.data[index].id == parseInt(response.data[index].id)){
              state.xeroclient.data[index].sync_percent = parseInt(response.data[index].sync_percent);
              state.xeroclient.data[index].lastsync = parseInt(response.data[index].lastsync);
              }
              state.xeroclient.data[index].notification = response.data[index].notification;
              msg = msg +", "+ response.data[index].notification;
             //Notification["success"]({
             // message:"Now Synced",
             // description: msg,
             // });
              // console.log(selected_bulk_ids);
            });
            
          },
          (error) => {
            
          }
        );
      }
    };

    const xerodisconnect = (tenent_id) => {
      dispatch("xerodisconnect",tenent_id).then(
        (response) => {
        //location.reload(true);
          //xerocheck();
          Notification["success"]({
            message: "Succsess!",
            description: "Client Disconnected.",
            });
          router.push("/");
        },
        (error) => {
        //location.reload(true);
        Notification["error"]({
          message: "API Error!",
          description: "Error Disconnecting Client",
        });
          //xerocheck();
          // console.log(error);
        }
      );
    };
  const qbodisconnect = (tenent_id) => {
      dispatch("qbodisconnect",tenent_id).then(
        (response) => {
          Notification["success"]({
            message: "Succsess!",
            description: "QBO Client Disconnected.",
            });
          router.push("/");
        },
        (error) => {
        Notification["error"]({
          message: "API Error!",
          description: "Error Disconnecting Client",
        });
        }
      );
    };  

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        selectedRowKeys.value = selectedRowKeys;
        selectedRows.value = selectedRows;
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User",
        name: record.name,
      }),
    };

    const showEditModal = (data) => {
      console.log(data);
    };

    const onHandleDelete = (id) => {
      console.log(id);
    };

    const handlesort = () => {
      var data = {};
      dispatch("clientdatasort", data);
    };

    const overviewpage = (id,vendor) => {
      if (id !== undefined) {
        if (vendor !=='QBO'){
        localStorage.setItem("org", id);
        //router.push({ path: "/overview" });
        router.push({ path: "/new-dashboard" });
        }
        else {
        localStorage.setItem("org", id);
        router.push({ path: "/qbo" });
        }
      }
    };
    const showpercent = (id) => {
    return id;
      
    };
    const startactive = (id, tenent_id) => {
      console.log(id);
      dispatch("onStarUpdate", { id: id, tenent_id: tenent_id }).then(
        (response) => {
          xerocheck();
        },
        (error) => {
          // console.log(error);
          empty.value = true;
        }
      );
    };
    var usersTableData = computed(() => state.xeroclient.data);

    const xeroconnect = () => {
      window.location.href = API_ENDPOINT + "xero/authorization.php?app_id=1";
    };

     const xeroResync = (tenent_id) => {

      dispatch("getResync",tenent_id).then(
        (response) => {
          location.reload()
        },
        (error) => {}
      );
    };
 const xeroreconnect = (tenent_id) => {
     dispatch("xerorefresh",tenent_id).then(
        (response) => {
        //location.reload(true);
        xerocheck();
        },
        (error) => {
        //window.location.reload(true);
          xerocheck();
          // console.log(error);
        }
      ); 
    };


    return {
      rowSelection,
      empty,
      usersTableData,
      showEditModal,
      showModal,
      localState,
      openModal,
      openModal1,
      openModal2,
      handleCancel,
      orgdata,
      handlesort,
      startactive,
      overviewpage,
      showpercent,
      xerodisconnect,
      qbodisconnect,
      xeroconnect,
      xeroreconnect,
      loading,
      xeroResync,
      counts,
      
    };
  },
});
</script>
<style>
.ant-list-items {
  padding-top: 0px !important;
}

.highlighted {
  margin: 10px !important;
  border-spacing: 0 8px !important;
}

.product-list:hover {
  -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
</style>